import { Component } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';

@Component({
  selector: 'app-sfa',
  templateUrl: './sfa.component.html',
  styleUrls: ['./sfa.component.scss']
})
export class SfaComponent extends GridBaseCase {

  constructor() { super(); }

  ngOnInit() {
    // console.log(this.config);
    // console.log(11111);
  }

}
